module.exports = __webpack_public_path__ + "static/media/fyVideo.a69f5aa.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/fyVideo.mp4
// module id = yUUB
// module chunks = 3